import { doc, getDoc, setDoc } from 'firebase/firestore';
import type { Firestore } from 'firebase/firestore';
import type { Track } from '../types/Track';

const playlistRef = (db: Firestore, uid: string) => doc(db, 'users', uid, 'data', 'playlist');

type PlaylistDocument = { items?: Track[] };

export async function loadPlaylist(db: Firestore, uid: string): Promise<Track[]> {
  const snapshot = await getDoc(playlistRef(db, uid));
  if (!snapshot.exists()) return [];
  const data = snapshot.data() as PlaylistDocument;
  return Array.isArray(data.items) ? data.items : [];
}

function cleanForFirestore<T>(data: T): T {
  return JSON.parse(JSON.stringify(data));
}

export async function savePlaylist(db: Firestore, uid: string, items: Track[]): Promise<void> {
  await setDoc(playlistRef(db, uid), { items: cleanForFirestore(items) }, { merge: true });
}

